import { createContext, FC, ReactElement, useCallback, useContext, useState } from 'react'
import Modal from '../../components/modal'
import { RoutesEnum } from '../../utils/routesEnum'

type ErrorRequest = {
  response?: {
    data?: {
      message?: string
      errorCode?: string
    }
  }
}

type Message = {
  okText: string
  to?: string
  message: string | ReactElement
}
interface IAlertHandle {
  showError: (error: ErrorRequest) => void;
  showSuccess: (message: string) => void;
}

const ACTIONS: { [key: string]: Message } = {
  YOU_NEED_TO_HAVE_A_PLAN_TO_ACCESS_IT: {
    okText: 'ASSINAR PLANO',
    to: RoutesEnum.SUBSCRIPTION,
    message: (
      <>
        Para começar só falta um passo, escolher seu plano.
        <br /><br />
        <small>Não se preocupe o pagamento só será efetivado quando seu periodo de teste finalizar e você pode cancelar a qualquer momento antes da cobrança.</small>
      </>
    )
  }
}

const AlertHandlerContext = createContext<IAlertHandle>({} as IAlertHandle)

export const useAlertHandler = (): IAlertHandle => {
  const context = useContext(AlertHandlerContext)
  if (!context) {
    throw new Error('useAlertHandler must be used within an AlertHandlerContext')
  }

  return context
}

export const AlertHandlerProvider: FC = ({ children }): ReactElement => {
  const [isOpen, setOpen] = useState(false)
  const [message, setMessage] = useState<Message>({} as Message)
  const [type, setType] = useState('error')

  const showError = useCallback((error: ErrorRequest) => {
    setOpen(true)
    setType('error')

    const code = error?.response?.data?.errorCode
    if (code && ACTIONS[code]) {
      setMessage(ACTIONS[code])
    } else {
      const message = error?.response?.data?.message
      setMessage({
        okText: 'OK',
        message: message || 'Oops, algo de errado aconteceu'
      })
    }
  }, [setOpen, setMessage])

  const showSuccess = useCallback((message) => {
    setOpen(true)
    setType('success')

    setMessage(message)
  }, [setOpen, setMessage])

  return (
    <AlertHandlerContext.Provider
      value={{
        showError,
        showSuccess
      }}
    >
      {children}
      {isOpen && (
        <Modal
          title={type === 'error' ? 'Oops' : 'Sucesso'}
          okButtonText={message.okText || 'OK'}
          onOk={() => {
            setOpen(false)
            if (message.to) window.location.href = message.to
          }}
        >
          {message.message}
        </Modal>
      )}
    </AlertHandlerContext.Provider>
  )
}
